import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Visibility, Add, Map } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll, wsUpdate } from 'services/WService.js';

//modal
import Modal from './Modal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import ModalNewZone from './ModalNewZone';
import ButtonDelete from 'hooks/ButtonDelete';
import { Box, Switch } from '@material-ui/core';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  size: {
    fontSize: '4.4rem',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '# Acciones', accessor: 'num', excelEnabled: false },
  { Header: 'Polígono', accessor: 'polygon' },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Zona', accessor: 'name' },
  { Header: 'Nombre almacén', accessor: 'warehouse' },
  { Header: 'Estado', accessor: 'state' },
  { Header: 'GPS falso choferes', accessor: 'gpsChoferes', excelEnabled: false, width: 140 },
  { Header: 'GPS falso supervisores', accessor: 'gpsSupervisores', excelEnabled: false, width: 140 },
  { Header: 'Versión choferes', accessor: 'verChoferes', excelEnabled: false, width: 140 },
  { Header: 'Versión supervisores', accessor: 'verSupervisores', excelEnabled: false, width: 140 },
  { Header: '', accessor: 'actions', excelEnabled: false },
];

export default WithApp(function Zone(props) {
  const [notify, showNotify] = useToasty();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [openNewZone, setOpenNewZone] = useState(false); //cambiar a false
  const [zone, setZone] = useState({});
  const [layers, setLayers] = useState({});

  const [zones, setZones] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  async function loadZones() {
    setDataLoading(true);
    let response = await wsGetAll('base/zone');
    setDataLoading(false);
    if (response.success) setZones(response.data);
  }

  async function listLayers() {
    setDataLoading(true);
    let response = await wsGetAll('base/layer');
    setDataLoading(false);
    if (response.success) setLayers(response.data);
  }

  //aplica una validación a todos los choferes o supervisores de la zona;
  //los vendedores no se tocan acá, ellos se administran por mesa
  async function aplicarValidacion(zone, app, campo, activo) {
    setDataLoading(true);
    let response = await wsUpdate(`base/zone/${zone.id}/validations`, {
      app,
      [campo]: activo ? 1 : 0
    });
    setDataLoading(false);

    if (response.success) showNotify(response.message);
    else showNotify(response.message, 'error');

    loadZones();
  }

  //el switch va prendido solo si TODOS los del grupo la tienen activa
  function switchValidacion(zone, app, campo) {
    const esDelivery = app === 'delivery';
    const total = esDelivery ? zone.choferes_movil : zone.supervisores_movil;
    const marcados = esDelivery
      ? zone[`choferes_${campo}`]
      : zone[`supervisores_${campo}`];
    return (
      <Switch
        checked={total > 0 && marcados === total}
        disabled={dataLoading || !total}
        onChange={(e) => aplicarValidacion(zone, app, campo, e.target.checked)}
        color="secondary"
      />
    );
  }

  useEffect(() => {
    loadZones();
    listLayers();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal
        open={open}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadZones}
        zoneId={zone.id}
        layers={layers}
      />

      <ModalNewZone
        open={openNewZone}
        setOpen={setOpenNewZone}
        zone={zone}
        setZone={setZone}
        reload={loadZones}
        showNotify={showNotify}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_ZONES_STORE}
              component={
                <CardIcon color="primary">
                  <Map style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                color="success"
                onClick={() => {
                  setOpenNewZone(true);
                }}
                pointer="true"
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Zonas{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Zonas"
              defaultWidth={1000}
              indexRow={[0, 1, 2, 5, 6, 7, 8, 9, 10]}
              widthRow={[160, 100, 100, 120, 140, 140, 140, 140, 10]}
              columns={columns}
              data={zones.map((zone, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <Box display="flex" alignItems="center">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_ZONES_SHOW}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColor}
                          onClick={() => {
                            setOpen(true);
                            setZone(zone);
                          }}
                          className="like"
                        >
                          <Visibility />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_ZONES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => {
                            setOpenNewZone(true);
                            setZone(zone);
                          }}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_ZONES_DELETED}>
                        <ButtonDelete entity="base/zone" id={zone.id} reload={loadZones} />
                      </AllowedGuard>
                    </Box>
                  ),
                  polygon: zone.geometry !== null ? 'Si' : 'No',
                  code: zone.code,
                  name: zone.description,
                  warehouse: zone.WhsName,
                  state: zone.state === 'A' ? 'Activo' : 'Inactivo',
                  gpsChoferes: (
                    <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                      {switchValidacion(zone, 'delivery', 'false_gps')}
                    </AllowedGuard>
                  ),
                  gpsSupervisores: (
                    <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                      {switchValidacion(zone, 'supervisor', 'false_gps')}
                    </AllowedGuard>
                  ),
                  verChoferes: (
                    <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                      {switchValidacion(zone, 'delivery', 'validate_version')}
                    </AllowedGuard>
                  ),
                  verSupervisores: (
                    <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                      {switchValidacion(zone, 'supervisor', 'validate_version')}
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
